import { extractPayload } from '@shared/utils';
import axios from 'axios';
import {isUndefined, isEmpty, forOwn, assign, clone} from 'lodash';
import { API_PREFIX } from '@shared/globals';

export const MODULE_NAME = 'passwordreset';

export const MUTATIONS = {
    SET_RECOVERY_QUESTIONS: 'setRecoveryQuestions',
    SET_RECOVERY_ANSWERS: 'setRecoveryAnswers',
    SET_USER_NAME: 'setUserName'
};

function api() {
    let instance = axios.create({
        baseURL: `/${API_PREFIX}/static/passwordreset`,
        headers: {},
        withCredentials: true,
    });

    return instance;
}

export default {
    name: MODULE_NAME,
    namespaced: true,

    state: {
        apiOptions: {
            baseURL: `/${API_PREFIX}/static/passwordreset`, // `/dartX/api/passwordreset`,
            headers: {},
            withCredentials: true,
        },
        recoveryQuestions: [],
        recoveryAnswers: [],
        userName: '',
    },

    mutations: {
        setRecoveryQuestions(state, payload) {
            state.recoveryQuestions = payload;
        },
        setRecoveryAnswers(state, answers) {
            let recoveryAnswers = [];

            forOwn(answers, (val, key) => {
                recoveryAnswers.push({
                    id: key,
                    caption: val,
                });
            });

            state.recoveryAnswers = recoveryAnswers;
        },
        setUserName(state, username) {
            state.userName = username;
        }
    },

    getters: {
        getRecoveryQuestions: (state) => () => {
            return state.recoveryQuestions;
        },
        getRecoveryAnswers: (state) => () => {
            return state.recoveryAnswers;
        },
        getUserName: (state) => () => {
            return state.userName;
        },
        // passwordreset API add headers 'x-user-id'
        getApi: (state) => () => {
            let apiOptions = clone(state.apiOptions);
            apiOptions.headers = {
                'x-user-id': state.userName
            };
            console.log('apiOptions: ', apiOptions);
            let instance = axios.create(apiOptions);

            return instance;
        },
    },

    actions: {
        checkUsername({ commit, getters }, payload) {
            let a = getters.getApi(); // api();
            return a
                .post('/check', payload)
                .then(extractPayload)
                .then((payload) => {
                    const questions = payload.questions;
                    if (isUndefined(questions) || isEmpty(questions)) {
                        return;
                    }
                    commit(MUTATIONS.SET_RECOVERY_QUESTIONS, questions);
                });
        },
        setAnswers({ commit }, answers) {
            if (isUndefined(answers) || isEmpty(answers)) {
                return;
            }
            commit(MUTATIONS.SET_RECOVERY_ANSWERS, answers);
        },

        resetPassword({ getters }, payload) {
            let answers = getters.getRecoveryAnswers();
            let apiRequest = assign({}, payload, { answers: answers });

            let a = getters.getApi();       // api();
            return a.post('/new', apiRequest).then(extractPayload);
        },
    },
};



// WEBPACK FOOTER //
// ./login/store/passwordreset.js